import { useCallback, useRef, useState } from 'react';

import WeChatDefaultBrowserOverlay from '@/components/AgentShare/components/WeChatDefaultBrowserOverlay';
import { GooglePlayLink, YingYongBaoLink } from '@/utils/call-app';
import reportClick, { EReportClickKey } from '@/utils/report/reportClick';
import { isAndroid, isApple, isWeChat } from '@/utils/utils';

import { useRegion } from './useAppEnv';
import useOpenApp from './useOpenApp';

interface IProps {
  path: string;
  params?: Record<string, any>;
}
const useOneClick2App = (
  props?: IProps
): {
  clickToApp: () => void;
  WeChatBrowserOverlay: React.ReactNode;
} => {
  // Use ref to always get the latest props value
  const propsRef = useRef(props);

  propsRef.current = props;

  const { openApp, openULApp } = useOpenApp();
  const { region } = useRegion();
  const [showWeChatBrowserOverlay, setShowWeChatBrowserOverlay] = useState(false);

  const handleGetApp = useCallback(() => {
    const openAppRoute = propsRef.current;

    reportClick(EReportClickKey.get_app_clicked);

    if (isWeChat()) {
      if (isApple()) {
        // Wechat iOS - UL
        if (openAppRoute) {
          openULApp?.(openAppRoute.path, openAppRoute.params);
        } else {
          openULApp?.();
        }

        return;
      }

      if (isAndroid()) {
        // Wechat Android - show browser overlay if has route, otherwise download
        if (openAppRoute) {
          setShowWeChatBrowserOverlay(true);

          return;
        }

        window.location.href = region == 'cn' ? YingYongBaoLink : GooglePlayLink;

        return;
      }

      if (openAppRoute) {
        openApp?.(openAppRoute.path, openAppRoute.params);
      } else {
        openApp?.();
      }

      return;
    }

    if (isApple()) {
      // Browser iOS - schema
      if (openAppRoute) {
        openApp?.(openAppRoute.path, openAppRoute.params);
      } else {
        openApp?.();
      }

      return;
    }

    if (isAndroid()) {
      // Browser Android - intent schema
      if (openAppRoute) {
        openApp?.(openAppRoute.path, openAppRoute.params);
      } else {
        openApp?.();
      }

      return;
    }

    // 兜底
    if (openAppRoute) {
      openApp?.(openAppRoute.path, openAppRoute.params);
    } else {
      openApp?.();
    }
  }, [openApp, openULApp, region]);

  const WeChatBrowserOverlay = (
    <WeChatDefaultBrowserOverlay
      onClose={() => setShowWeChatBrowserOverlay(false)}
      visible={showWeChatBrowserOverlay}
    />
  );

  return { clickToApp: handleGetApp, WeChatBrowserOverlay };
};

export default useOneClick2App;
